<template>
  <a-modal
    :title="null"
    :width="420"
    :visible="visible"
    :footer="null"
    @cancel="handleCancel"
  >
    <a-tabs default-active-key="1">
      <a-tab-pane key="1" tab="忘记密码">
        <div v-if="step ===1" class="pl-60 pr-60 pt-20">
          <div class="fs-b fs-16 t-center">找回密码</div>
          <div class="mb-20 mt-20"><a-input v-model="acc" placeholder="请输入手机号/用户名/子账号" /></div>
          <div class="mb-20"><a-button class="w-100p" type="primary" @click="first">下一步</a-button></div>
        </div>
        <div v-if="step ===9" class="pl-60 pr-60 pt-20">
          <div class="fs-b fs-16 t-center">正在找回密码...</div>
          <div class="mb-20 mt-20">
            经系统检测您输入的：{{ accInfo&&accInfo.userName }} 是企业子账号<br>
            请联系 {{ accInfo&&accInfo.companyName }} 的企业管理员（{{ accInfo&&accInfo.contactName }}）为您重置密码。
          </div>
          <div class="mb-20"><a-button class="w-100p" type="primary" @click="close">关闭</a-button></div>
        </div>
        <div v-if="step===2" class="pl-60 pr-60 pt-20">
          <a-form-model ref="form" :model="form1" :rules="loginRules1">
            <a-form-model-item prop="userName">
              <a-input v-model="form1.userName" :disabled="true" placeholder="登录名" />
            </a-form-model-item>
            <a-form-model-item prop="mobilePhone">
              <a-input v-model="form1.mobilePhone" placeholder="手机号码" />
            </a-form-model-item>
            <a-form-model-item prop="validateCode">
              <a-input v-model="form1.validateCode" type="验证码" placeholder="验证码">
                <CountDown slot="suffix" :count="60" @start="countDown" />
              </a-input>
            </a-form-model-item>
            <a-form-model-item>
              <a-button
                class="w-100p"
                type="primary"
                :loading="formLoading"
                @click="postForm1"
              >
                下一步
              </a-button>
            </a-form-model-item>
          </a-form-model>

        </div>
        <div v-if="step===3" class="pl-60 pr-60 pt-20">
          <a-form-model ref="form2" :model="form2" :rules="loginRules2">
            <a-form-model-item prop="pwd1">
              <a-input v-model="form2.pwd1" placeholder="输入新密码" />
            </a-form-model-item>
            <a-form-model-item prop="pwd2">
              <a-input v-model="form2.pwd2" placeholder="确认输入新密码" />
            </a-form-model-item>
            <a-form-model-item>
              <a-button
                class="w-100p"
                type="primary"
                :loading="formLoading2"
                @click="postForm2"
              >
                确认
              </a-button>
            </a-form-model-item>
          </a-form-model>

        </div>
        <div v-if="step ===4" class="pl-60 pr-60 pt-20">
          <div class="fs-b fs-16 t-center">恭喜您，成功修改密码</div>
          <div class="mb-20 mt-20 t-center">{{ sec }}后会自动跳转到<span class="pointer" @click="window.location.href='/'">登录</span>首页</div>
        </div>
      </a-tab-pane>
    </a-tabs>
  </a-modal>
</template>
<script>
import CountDown from '../CountDown'
import { getToken, setToken } from '@framework/utils/auth' // get token from cookie
import validate from '@framework/utils/biz-validate'

export default {
  components: {
    CountDown
  },
  data() {
    const validateMobile = (rule, value, callback) => {
      if (!validate.mobile.pattern.test(value)) {
        callback(new Error(validate.mobile.msg))
      } else {
        callback()
      }
    }
    const validateUsername = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入正确的用户名'))
      } else {
        callback()
      }
    }
    const validatePassword = (rule, value, callback) => {
      if (value.length < 6) {
        callback(new Error('密码最少需要6位'))
      } else {
        callback()
      }
    }
    const validateChangePassword = (rule, value, callback) => {
      if (value.length < 6) {
        callback(new Error('密码最少需要6位'))
      } else if (
        this.form2.pwd1 &&
        this.form2.pwd2 &&
        this.form2.pwd1 === this.form2.pwd2
      ) {
        callback()
      } else {
        callback(new Error('两次输入的密码不一致'))
      }
    }
    return {

      loginRules1: {
        userName: [
          { required: true, trigger: 'blur', validator: validateUsername }
        ],
        mobilePhone: [
          { required: true, trigger: 'blur', validator: validateMobile }
        ],
        userPassword: [
          { required: true, trigger: 'blur', validator: validatePassword }
        ],
        companyName: [
          { required: true, trigger: 'blur', message: '请输入公司名称' }
        ],
        linkMan: [
          { required: true, trigger: 'blur', message: '请输入联系人姓名' }
        ],
        validateCode: [
          { required: true, trigger: 'blur', message: '请输入验证码' }
        ]
      },
      loginRules2: {
        pwd1: [
          { required: true, trigger: 'blur', message: '请输入新密码' }
        ],
        pwd2: [
          { required: true, trigger: 'blur', validator: validateChangePassword }
        ]
      },
      visible: false,
      confirmLoading: false,
      form2: {
        'pwd1': '',
        'pwd2': ''
      },
      form1: {
        'companyName': '',
        'linkMan': '',
        'mobilePhone': '',
        'userName': '',
        'userPassword': '',
        'validateCode': ''
      },
      formLoading2: false,
      formLoading: false,
      jump: '',
      step: 1,
      acc: '',
      accInfo: null,
      sec: 0
    }
  },
  methods: {
    async countDown(count) {
      this.$refs.form.validateField('mobilePhone', async(err) => {
        if (!err) {
          const res = await this.$http({ ...this.$api.loginFindPasswordGetCode, origin: true }, {
            mobilePhone: this.form1.mobilePhone,
            account: this.form1.userName
          })
          if (res.data.state === 'success') {
            count.next()
          } else {
            this.$message.error(res.data.msg)
          }
        }
      })
    },
    async first() {
      if (!this.acc) {
        this.$message.error('请输入手机号/用户名/子账号')
        return
      }
      const res = await this.$http(this.$api.loginFindPasswordCheckAccount, {
        'account': this.acc
      })
      this.accInfo = res
      if (this.accInfo.role === 1) {
        this.step = 2
        this.form1.userName = this.accInfo.userName
      } else {
        this.step = 9
      }
    },
    close() {
      this.jump = ''
      this.visible = false
    },
    show(path) {
      this.jump = path
      this.visible = true
    },
    toLogin() {
      this.visible = false
      this.$login.show()
    },
    postForm1() {
      this.$refs.form.validate(async v => {
        if (v) {
          this.formLoading = true
          try {
            const res = await this.$http(this.$api.loginFindPasswordCheckCode, {
              'account': this.form1.userName,
              'code': this.form1.validateCode,
              'mobilePhone': this.form1.mobilePhone
            })
            if (res) {
              this.formLoading = false
              this.step = 3
            }
          } catch (error) {
            this.formLoading = false
          }
        }
      })
    },
    postForm2() {
      this.$refs.form2.validate(async v => {
        if (v) {
          this.formLoading2 = true
          try {
            const res = await this.$http(this.$api.loginfindPasswordEditPassword, {
              'account': this.form1.userName,
              'code': this.form1.validateCode,
              'mobilePhone': this.form1.mobilePhone,
              'newPassword': this.form2.pwd1,
              'newPasswordConfirm': this.form2.pwd2
            })
            if (res) {
              this.formLoading2 = false
              this.step = 4
              this.sec = 3
              const t = setInterval(() => {
                if (this.sec === 0) {
                  clearInterval(t)
                  window.location.href = '/'
                  return
                }
                this.sec--
              }, 1000)
            }
          } catch (error) {
            this.formLoading2 = false
          }
        }
      })
    },
    handleCancel(e) {
      this.visible = false
    }
  }
}
</script>
